module.exports = __webpack_public_path__ + "static/img/top01.8232fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top01.png
// module id = VXHW
// module chunks = 1